/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCompanyAgentsResponse } from '../../models/get-company-agents-response';

export interface GetApiAdministrativeV1IdAgents$Json$Params {

/**
 * The unique identifier of the company.
 */
  id: number;

/**
 * The page number for pagination.
 */
  Page?: number;

/**
 * The number of items per page.
 */
  PageSize?: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
}

export function getApiAdministrativeV1IdAgents$Json(http: HttpClient, rootUrl: string, params: GetApiAdministrativeV1IdAgents$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCompanyAgentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getApiAdministrativeV1IdAgents$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('Page', params.Page, {});
    rb.query('PageSize', params.PageSize, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCompanyAgentsResponse>;
    })
  );
}

getApiAdministrativeV1IdAgents$Json.PATH = '/private/v1/companies/{id}/agents';
